// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7742":"f25aa6d1","8101":"b336b1be"}[chunkId] + ".chunk.css";
};